export default __webpack_public_path__ + "static/img/elephant.54a0ec5.jpg";